const redirect = (location) => {
    const a = document.createElement('a');
    a.href = location;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export default redirect;